import { Col, Row } from 'reactstrap';

import {
  ContinuousEducationSectionSchedulesLoader,
  useContinuousEducationSectionSchedulesLoader,
} from '../../../../SectionsEdit/hooks/ContinuousEducationSectionSchedulesLoader';
import SectionScheduleForm from './SectionSchedule/SectionScheduleForm';
import { AcademicOfferScheduleSection } from '../../../types';
import { AcademicOfferScheduleEmpty } from './AcademicOfferScheduleEmpty';

interface SectionScheduleTableWrapperProps {
  onScheduleSaved: () => void;
}

function SectionScheduleTableWrapper({
  onScheduleSaved,
}: SectionScheduleTableWrapperProps) {
  const { result } = useContinuousEducationSectionSchedulesLoader();
  const data = result?.success ? result.data : null;

  const handleSave = () => {
    onScheduleSaved();
  };

  if (!data) {
    return <AcademicOfferScheduleEmpty />;
  }

  return <SectionScheduleForm data={data} onSave={handleSave} />;
}

interface AcademicOfferSectionScheduleTablesProps {
  sections: AcademicOfferScheduleSection[];
  onScheduleSaved: () => void;
}

export function AcademicOfferSectionScheduleTables({
  sections,
  onScheduleSaved,
}: AcademicOfferSectionScheduleTablesProps) {
  return (
    <Row>
      <Col xs={12} className="m-auto">
        {sections.map((section, index) => (
          <div
            key={section.id}
            className={`d-flex flex-column justify-content-center${
              index > 0 ? ' mt-4' : ''
            }`}
          >
            <ContinuousEducationSectionSchedulesLoader
              defaultQuery={section.id}
              fetchImmediately
            >
              <SectionScheduleTableWrapper onScheduleSaved={onScheduleSaved} />
            </ContinuousEducationSectionSchedulesLoader>
          </div>
        ))}
      </Col>
    </Row>
  );
}
